import SuperJSON from "superjson";
import Id from "../types/Id";

export default class InviteId extends Id<"invite"> {}

SuperJSON.registerClass(InviteId, { identifier: "InviteId" });
